import {useState, useContext} from 'react'
import Link from 'next/link'
import s from './index.module.css'
import THEME_DATA from './theme'
import { UserContext } from 'components/UserProvider'

interface gameProps {
  name: string
  link: string
  desc: string
  image: string
}

interface themeProps {
  type: string
  games: gameProps[]
}

const MAX_CARDS = 3 // 最多同时展示的游戏卡片个数

export default function ThemeModal() {
  const [themeInx, setThemeInx] = useState(0)
  const [gameInx, setGameInx] = useState(0)
  const {themeModalStatus, dispatch, from} = useContext(UserContext)

  const handleArrow = (e: any, direction: string, gameNums: number) => {
    e.stopPropagation()
    const min = 0, max = Math.floor(gameNums / MAX_CARDS)
    let curGameInx = direction === 'right' ? gameInx + 1 : gameInx - 1
    curGameInx = Math.min(max, curGameInx)
    curGameInx = Math.max(min, curGameInx)
    setGameInx(curGameInx)
  }

  const handleTheme = (e: any, index: number) => {
    e.stopPropagation()
    setThemeInx(index)
    setGameInx(0)
  }

  const renderType = () => (
    <div className={s.themeType}>
      {THEME_DATA.map((theme: themeProps, index: number) => (
        <div
          key={theme.type} 
          onClick={(e:any) => handleTheme(e, index)}
          className={`${s.btn} ${themeInx === index ? s.activeBtn : ''}`}
        >{theme.type}</div>
      ))}
    </div>
  )

  const renderGameCards = () => (
    THEME_DATA[themeInx].games.map((game: gameProps) => (
      <Link href={`${game.link}?from=${from}`} key={game.name}>
        <div className={s.gameCard}>
          <div className={s.cardImg} style={{backgroundImage: `url(${game.image})`}}></div>
          <div className={s.cardTitle}>{game.name}</div>
          <div className={s.cardDesc}>{game.desc}</div>
        </div>
      </Link>
    ))
  )
  
  const renderGame = () => {
    const gameNums = THEME_DATA[themeInx].games.length

    // 游戏个数超出3个，展示切换箭头
    if(gameNums > MAX_CARDS) {
      return (
        <div className={s.games}>
          <div className={`${s.gamearrow} ${s.gamearrowleft}`} onClick={(e)=> handleArrow(e, 'left', gameNums)}></div>
          <div className={s.gameCardsCt}>
            <div 
              className={s.gameCards} 
              style={{
                transform: `translateX(-${888 * gameInx}px)`,
                transition: 'all 0.5s linear'
              }}
            >
              {renderGameCards()}
            </div>
          </div>
          <div className={`${s.gamearrow} ${s.gamearrowright}`} onClick={(e)=> handleArrow(e, 'right', gameNums)}></div>
        </div>
      )
    }

    return (
      <div className={s.games}>
        <div className={s.gameCards}>
          {renderGameCards()}
        </div>
      </div>
    )
  }

  if(themeModalStatus === 'show') {
    return (
      <div className={s.mask} onClick={() => {dispatch({ type: 'hideThemeModal' })}}>
        <div className={s.modal}>
          <div className={s.title}>选择一个你喜欢的主题，然后尽情发挥创意吧</div>
          <div className={s.content}>
            {renderType()}
            {renderGame()}
          </div>
        </div>
      </div>
    )
  }
  return null
}
